"use client";

export default function Premiumtrustreviews() {
  return <section id="reviews" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        
      </div>
    </section>;
}